import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-radio-btn-off"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><g class=\"\"><rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill\"></rect></g><g class=\"\"><circle cx=\"22\" cy=\"22\" r=\"10\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></circle></g></g><g class=\"\"><rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill icon-fi--filled\"></rect><g class=\"\" transform=\"translate(-5567.063 -359.029)\"><circle cx=\"5589.1\" cy=\"381\" r=\"10\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></circle></g></g>", 2)
  ]), 16))
}
export default { render: render }